<template>
 <div id="containerbar" >
        <!-- Start Container -->
        <div class="container">
            <div class="auth-box login-box">
                <!-- Start row -->
                <div class="row no-gutters align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-12 col-lg-12">
                        <!-- Start Auth Box -->
                        <div class="auth-box-right">
                            <div class="card">
                                <div class="card-body">

                                   
                                        <div class="form-head border-0" >
                                            <a href="/" class="logo"><img src="assets/images/logo.svg" class="img-fluid" alt="logo"></a>
                                        </div>                                        
                                      
                                        
                                       
                                        <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>   
                                    <b-row v-if="successmessage!=''">
                                        <b-col cols="12" class="text-center alert alert-success">
                                            {{successmessage}}
                                        </b-col>

                                    </b-row>                      
                                      <button type="submit" v-if="!sending" class="btn btn-info btn-lg btn-block font-18 mb-3">Richiedi oblio</button>
                                     
                                   
                                   
                                </div>
                            </div>
                        </div>
                        <!-- End Auth Box -->
                    </div>
                    <!-- End col -->
                </div>
                <!-- End row -->
            </div>
        </div>
        <!-- End Container -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ViewOblivion',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      errormessage: '',
      successmessage:'',
      sending: false
    };
  },
  mounted(){

      this.attemptLogin();
  },
  methods: {
      attemptLogin() {
          var me = this;
     me.successmessage = me.errormessage = "";
         this.sending = true;
             axios.post('user/oblivionconfirm/'+this.$route.params.id).then(response => {

                      if (response.status == 200 && !response.data.error) {
                          me.successmessage="Perfetto, la tua richiesta è stata accettata."
                      }
                      else {
                          me.sending = false;
                          me.errormessage = 'Attenzione, non riconosco la tua mail';
                      }


                  }) 
                  .catch(error => {
                     me.sending = false;
                      me.errormessage = 'Attenzione, non riconosco la tua mail';
                  });

    }
  }
};
</script>
